<template>

    <el-col :span="8">
        <div >
            <el-card class="box-card" style="height:300px;" v-loading="loading">
                <div slot="header" class="clearfix">
                    <span>数据中心机柜</span>
                    <el-popover
                            placement="top"
                            title=""
                            width="200"
                            trigger="hover"
                            content="数据根据周报月报汇总统计">
                        <el-button slot="reference" type="text" style="float:right;padding: 3px 0;color:#666;"><i class='el-icon-question'></i></el-button>
                    </el-popover>
                    <el-select  v-show="false" v-model="searchSysRoom" collapse-tags size="small" style="width: 220px;float:right;margin-top:-6px;" multiple  @visible-change="roomChangeFun" placeholder="请选择">
                        <el-option
                                v-for="item in sysRooms"
                                :key="item.dcNum"
                                :label="item.name"
                                :value="item.dcNum">
                        </el-option>
                    </el-select>

                </div>
                <el-row >
                    <el-col :span="8">
                        <p class="orange-font bold bnum">{{rackTotal}}</p>
                        <p class="subnum">机柜总数</p>
                    </el-col>
                    <el-col :span="8">
                        <p class="orange-font bold bnum">{{signRack}}</p>
                        <p class="subnum">已签约机柜</p>
                    </el-col>
                    <el-col :span="8">
                        <p class="orange-font bold bnum">{{rackRatio}}</p>
                        <p class="subnum">机柜签约率</p>
                    </el-col>
                    <el-col :span="8">
                        <p class="orange-font bold bnum">{{produceElectricity}}</p>
                        <p class="subnum">生产上电</p>
                    </el-col>
                    <el-col :span="8">
                        <p class="orange-font bold bnum">{{signNoElectricity}}</p>
                        <p class="subnum">已签约未上电</p>
                    </el-col>
                    <el-col :span="8">
                        <p class="orange-font bold bnum">{{testElectricity}}</p>
                        <p class="subnum">测试上电</p>
                    </el-col>
                    <el-col :span="8">
                        <p class="orange-font bold bnum">{{grounding}}</p>
                        <p class="subnum">上架率</p>
                    </el-col>
                </el-row>

            </el-card>
        </div>
    </el-col>
</template>
<script>
    import {athubAxios} from '../../../../util'
    import {COMMON_SERVER} from '@/api/server'
    import {querySysRoomReportInfoOld,querySysRoomReportInfoNew,fetchSiteList
    } from '@/api/bossBoard/sysRoomRelevant/sysRoomBoard.js'
    export default {
        name: 'sysRoomBoard',
        components: {},
        data() {
            return {
                searchSysRoom:null,//数组 父页面选择框，由父页面传值进来
                searchMonth:null,//父页面的月份选择框由父页面传值进来,父页面如果取消月份选择的值，这边也要清空,父页面必填
                startTime:null,//根据searchMonth计算出来的开始时间
                endTime:null,//根据searchMonth计算出来的结束时间
                //这边值先默认写死后面等首页查询园区过滤条件直接根据园区查询对应数据中心在把值推送给这边
                sysRooms:null,
                rackTotal:null,//机柜总数
                signRack:null,//已签约机柜
                rackRatio:null,//机柜签约率
                produceElectricity:null,//生产上电
                signNoElectricity:null,//签约未上电
                testElectricity:null,//测试上电
                grounding:null,//上架率
                allDcnumReportPromise:[],//最后获取的月报值需要循环计算
                siteMap: null,//初始化获取授权地点
                loading : true
            }
        },
        methods: {
            //数据中心下拉框促发事件
            async roomChangeFun(boo){
            this.loading=true;
            if (boo == false) {//下拉框缩起来促发事件
            // 先清空对应的数据在下面计算从新赋值
            this.rackTotal = null;
            this.signRack = null;
            this.rackRatio = null;
            this.produceElectricity= null;
            this.signNoElectricity= null;
            this.testElectricity= null;
            this.grounding= null;
            this.allDcnumReportPromise=[];

            this.startTime = new Date(this.getTheMonthFirstLastDay(this.searchMonth + "-01", (
                    'yyyy-MM-dd hh:mm:ss'))[0]);
            this.endTime = new Date(this.getTheMonthFirstLastDay(this.searchMonth + "-01", (
                    'yyyy-MM-dd hh:mm:ss'))[1]);

            var now = new Date();
            var yearOfNow = now.getFullYear();
            var monthOfNow = now.getMonth() + 1;
            var dateOfNow = now.getDate();//

            var nowDate = new Date(yearOfNow + "/" + monthOfNow + "/" + dateOfNow);
            if (nowDate.getTime() <= this.endTime.getTime()) {
                //先赋值0
                this.rackTotal = 0;
                this.signRack = 0;
                this.rackRatio = 0 + '%';

                //查询当前日期减去七天
                var topSevenDate = new Date(nowDate);//上周最后一天
                topSevenDate.setDate(topSevenDate.getDate() - 7);
                if (monthOfNow == new Date(this.searchMonth).getMonth()+1) {//月份相等，那就是最大能选择得月份，取向上一周得周报数据
                if ((nowDate.getDay() == 1 || nowDate.getDay() == 2 || nowDate.getDay() == 3 || nowDate.getDay() == 4)
                &&(dateOfNow==1||dateOfNow==2||dateOfNow==3||dateOfNow==4)) {

                    let monthOfNowTmp = '';
                    if (String(monthOfNow - 1).length == 1) {
                        monthOfNowTmp = String(monthOfNow - 1).padStart(2, '0');
                        monthOfNowTmp = monthOfNowTmp == '00' ? '01' : monthOfNowTmp;
                    } else {
                        monthOfNowTmp = monthOfNow - 1;
                    }

                    var topStartTime = new Date(this.getTheMonthFirstLastDay(yearOfNow + "-" + monthOfNowTmp + "-01", (
                            'yyyy-MM-dd hh:mm:ss'))[0]);
                    var topEndTime = new Date(this.getTheMonthFirstLastDay(yearOfNow + "-" + monthOfNowTmp + "-01", (
                            'yyyy-MM-dd hh:mm:ss'))[1]);
                    var sp = {
                        "startTime": topStartTime.getTime(),
                        "endTime": topEndTime.getTime(),
                        "woType": 'MONTHLY',
                        "paging": false
                    }
                } else {//原本查实时的，现在改成查询当前时间往前推七天，然后对应的周报,周报是每周五生成上一周(上周五到这周四)得周报
                    var sp = {
                        "startTimeEnd": topSevenDate.getTime(),
                        "endTimeStart": topSevenDate.getTime(),
                        "woType": 'WEEKLY',
                        "paging": false
                    }
                }
            }

                //获取数据
                //for (var i = 0; i < this.searchSysRoom.length; i++) {
                    var oneDcnumSP = JSON.parse(JSON.stringify(sp));
                    //oneDcnumSP.dcnum = [this.searchSysRoom[i]];
                    oneDcnumSP.dcnum = this.searchSysRoom;
                    var queryString = encodeURIComponent(JSON.stringify(oneDcnumSP));
                    var data = querySysRoomReportInfoOld(queryString);
                    if(null!=data){
                        this.allDcnumReportPromise.push(data);
                    }
               // }

                Promise.all(this.allDcnumReportPromise).then((values) => {
                    //计算
                    var totalSaled = 0;
                    var totalUnsaled = 0;
                    var rackReports = [];

                    if (values && values.length > 0) {
                        values.forEach(
                                function (reports) {
                                    rackReports = rackReports.concat(reports);
                                }
                        )

                        //数据转换成rackReports数组里面一个一个实体然后循环计算
                        if (rackReports && rackReports.length > 0) {
                            for (var i = 0; i < rackReports.length; i++) {
                                var rackReport = rackReports[i].rackReport;
                                if (rackReport && rackReport.unsaled) {
                                    for (var j = 0; j < rackReport.unsaled.length; j++) {

                                        var oneUnsaled = rackReport.unsaled[j];

                                        var rackTakeAtEnding = oneUnsaled.rackTakeAtEnding;

                                        totalUnsaled += parseInt(rackTakeAtEnding);
                                    }
                                }

                                if (rackReport && rackReport.saled) {
                                    for (var j = 0; j < rackReport.saled.length; j++) {

                                        var oneSaled = rackReport.saled[j];

                                        var rackTakeAtEnding = oneSaled.rackTakeAtEnding;

                                        totalSaled += parseInt(rackTakeAtEnding);
                                    }
                                }
                            }
                            this.rackTotal = totalSaled + totalUnsaled;
                            this.signRack = totalSaled;
                            this.rackRatio = ((totalSaled / (totalSaled + totalUnsaled)) * 100).toFixed(2)+'%';
                        }
                    }


                    //在计算生产上电，已签约上电，测试上电，上架率
                    this.calculationElectric(rackReports);
                });

            } else {
                //先赋值0
                this.rackTotal =0;
                this.signRack = 0;
                this.rackRatio = 0+'%';
                //查历史的
                var sp = {
                    "startTime": this.startTime.getTime(),
                    "endTime": this.endTime.getTime(),
                    "woType": 'MONTHLY',
                    "paging": false
                }

                //获取数据
               // for (var i = 0; i < this.searchSysRoom.length; i++) {
                    var oneDcnumSP = JSON.parse(JSON.stringify(sp));
//                    oneDcnumSP.dcnum = [this.searchSysRoom[i]];
                     oneDcnumSP.dcnum = this.searchSysRoom;
                    var queryString = encodeURIComponent(JSON.stringify(oneDcnumSP));
                    var data = querySysRoomReportInfoOld(queryString);
                    if(null!=data){
                        this.allDcnumReportPromise.push(data);
                    }
              //  }

                Promise.all(this.allDcnumReportPromise).then((values) => {
                    //计算
                    var totalSaled = 0;
                    var totalUnsaled = 0;
                    var rackReports = [];

                    if (values && values.length > 0) {
                        values.forEach(
                                function (reports) {
                                    rackReports = rackReports.concat(reports);
                                }
                        )
                        //数据转换成rackReports数组里面一个一个实体然后循环计算
                        if (rackReports && rackReports.length > 0) {
                            for (var i = 0; i < rackReports.length; i++) {
                                var rackReport = rackReports[i].rackReport;
                                if (rackReport && rackReport.unsaled) {
                                    for (var j = 0; j < rackReport.unsaled.length; j++) {

                                        var oneUnsaled = rackReport.unsaled[j];

                                        var rackTakeAtEnding = oneUnsaled.rackTakeAtEnding;

                                        totalUnsaled += parseInt(rackTakeAtEnding);
                                    }
                                }

                                if (rackReport && rackReport.saled) {
                                    for (var j = 0; j < rackReport.saled.length; j++) {

                                        var oneSaled = rackReport.saled[j];

                                        var rackTakeAtEnding = oneSaled.rackTakeAtEnding;

                                        totalSaled += parseInt(rackTakeAtEnding);
                                    }
                                }
                            }
                            this.rackTotal = totalSaled + totalUnsaled;
                            this.signRack = totalSaled;
                            this.rackRatio = ((totalSaled / (totalSaled + totalUnsaled)) * 100).toFixed(2)+'%';
                        }


                    }

                    //在计算生产上电，已签约上电，测试上电，上架率
                    this.calculationElectric(rackReports);
                });

            }
        }
        this.loading=false;
    },
    //获取当前年月日时间，月出（一号）到月末（31/30号）
    getTheMonthFirstLastDay(dateStr, fmt){
        var date = new Date(dateStr);
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return [firstDay.Format(fmt), lastDay.Format(fmt)];
    },
    //计算数据中心机柜上电情况
    calculationElectric(rackReports){
        //rackReports  是上面循环获取好的月报表数据,所有信息都在里面
        if( rackReports && rackReports.length >= 0 ){
            var totalInfo = [];//下面循环获取的值存放地
            for( var i=0;i<rackReports.length;i++ ){
                var reportWo   = rackReports[i];
                var rackReport = reportWo.rackReport;
                if( rackReport ){
                    if( rackReport.total ){
                        var oneTotal =  rackReport.total;
                        //获取中文名字
                        var siteName = "";
                        if( this.siteMap && this.siteMap.get( reportWo.siteId)){
                            siteName = this.siteMap.get( reportWo.siteId).description;
                        }

                        var unsaledTotal = 0;
                        if( rackReport.unsaled && rackReport.unsaled.length > 0 ){
                            if( rackReport && rackReport.unsaled ){
                                for( var j=0;j<rackReport.unsaled.length;j++ ){
                                    var oneUnsaled =   rackReport.unsaled[j];
                                    var rackTakeAtEnding = oneUnsaled.rackTakeAtEnding;
                                    unsaledTotal += parseInt( rackTakeAtEnding );
                                }
                            }
                        }

                        var onAtThisPeriod = 0;
                        var offAtThisPeriod = 0;
                        for(var o=0;o<rackReport.resourceStatusChangeWO.length;o++){
                                for(var g=0;g<rackReport.resourceStatusChangeWO[o].items.length;g++){
                                                if('ON' == rackReport.resourceStatusChangeWO[o].items[g].nextStatus){
                                                    onAtThisPeriod ++;
                                                }else if('OFF' == rackReport.resourceStatusChangeWO[o].items[g].nextStatus){
                                                    offAtThisPeriod ++;
                                                }
                                    }
                        }

                        let siteuid = 0;
                        if( this.siteMap.get( reportWo.siteId ) ){
                            siteuid   = this.siteMap.get( reportWo.siteId ).siteuid;
                        }

                        totalInfo.push(
                                {
                                    "dcnum"                 : reportWo.dcnum                             ,
                                    "siteId"                : reportWo.siteId                            ,
                                    "siteuid"               : siteuid                                    ,
                                    "siteName"              : siteName                                   ,
                                    "totalNumber"           : oneTotal.rackTakeAtEnding                  ,
                                    "onNumber"              : oneTotal.rackPowerOnProductionAtEnding     ,
                                    "testNumber"            : oneTotal.rackPowerOnTestAtEnding           ,
                                    "offNumber"             : oneTotal.rackJustOnAtEnding                ,
                                    "unsaledNumber"         : unsaledTotal                               ,
                                    "onAtThisPeriod"        : onAtThisPeriod                             ,
                                    "offAtThisPeriod"       : offAtThisPeriod
                                }
                        );
                    }
                }
            }

            //排序
            var dcnumGroupedTotalInfo =totalInfo.sort(this.compareInfo("siteuid"));
            //分组
            var map = new Map();
            for(var n=0;n<dcnumGroupedTotalInfo.length;n++){
                if(map.get(dcnumGroupedTotalInfo[n].siteId)){
                    var value=map.get(dcnumGroupedTotalInfo[n].siteId);
                    var dcnumGroupedTotalInfoNew=dcnumGroupedTotalInfo[n];
                    value.totalNumber=value.totalNumber+dcnumGroupedTotalInfoNew.totalNumber;
                    value.onNumber=value.onNumber+dcnumGroupedTotalInfoNew.onNumber;
                    value.testNumber=value.testNumber+dcnumGroupedTotalInfoNew.testNumber;
                    value.offNumber=value.offNumber+dcnumGroupedTotalInfoNew.offNumber;
                    value.unsaledNumber=value.unsaledNumber+dcnumGroupedTotalInfoNew.unsaledNumber;
                    value.onAtThisPeriod=value.onAtThisPeriod+dcnumGroupedTotalInfoNew.onAtThisPeriod;
                    value.offAtThisPeriod=value.offAtThisPeriod+dcnumGroupedTotalInfoNew.offAtThisPeriod;
                    map.set(value.siteId,value);
                }else{
                    var dcnumGroupedTotalInfoNew=JSON.parse(JSON.stringify(dcnumGroupedTotalInfo[n]));
                    map.set(dcnumGroupedTotalInfo[n].siteId,dcnumGroupedTotalInfoNew);
                }
            }
            //map转集合
            var sitemGroupedTotalInfo = [];
            sitemGroupedTotalInfo=[...map.values()];

            //在把一条一条的集合，相同字段的数据相加组成一条数据
            totalInfo={
                    "siteId"                : "ALL",
                    "siteName"              : "总数",
                    "totalNumber"           : 0,
                    "onNumber"              : 0,
                    "testNumber"            : 0,
                    "offNumber"             : 0,
                    "unsaledNumber"         : 0,
                    "onAtThisPeriod"        : 0,
                    "offAtThisPeriod"       : 0
            }
            for(var m=0;m<sitemGroupedTotalInfo.length;m++){
                totalInfo.totalNumber=sitemGroupedTotalInfo[m].totalNumber+totalInfo.totalNumber;
                totalInfo.onNumber=sitemGroupedTotalInfo[m].onNumber+totalInfo.onNumber;
                totalInfo.testNumber=sitemGroupedTotalInfo[m].testNumber+totalInfo.testNumber;
                totalInfo.offNumber=sitemGroupedTotalInfo[m].offNumber+totalInfo.offNumber;
                totalInfo.unsaledNumber=sitemGroupedTotalInfo[m].unsaledNumber+totalInfo.unsaledNumber;
                totalInfo.onAtThisPeriod=sitemGroupedTotalInfo[m].onAtThisPeriod+totalInfo.onAtThisPeriod;
                totalInfo.offAtThisPeriod=sitemGroupedTotalInfo[m].offAtThisPeriod+totalInfo.offAtThisPeriod;
            }
            //计算上架率
            var onRateData = ( ( totalInfo.onNumber / totalInfo.totalNumber ) * 100 ).toFixed(2);
            if( isNaN( onRateData ) ) onRateData = 0;
            totalInfo.onRateData = onRateData;
            //赋值页面
            this.produceElectricity=totalInfo.onNumber;
            this.signNoElectricity=totalInfo.offNumber-totalInfo.unsaledNumber;
            this.testElectricity=totalInfo.testNumber;
            this.grounding=totalInfo.onRateData+'%';

        }
    },
    compareInfo(property) {
        return function (a, b) {
            var value1 = a[property];
            var value2 = b[property];
            return value1 - value2;
        }
    }
    },
    created(){

    },
    mounted() {
        this.siteMap = new Map();
        //授权地点
        var sitePromise = fetchSiteList({
             "organization": {
                  "orgid": localStorage.getItem("authorg")
             }
        }).then((responseBody) => {
              responseBody.forEach((item, index) => {
              this.siteMap.set(item.siteid, item);
              })
              //alert(this.siteMap.get('ZB').description);
        });
    }
    }
</script>

